<p-confirmDialog />
<h3 class="with-manual-link">
  <span i18n="@@offline-websites">Offline-Websites</span>
  <app-manual-link
    href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Skills/Offline-Websites"></app-manual-link>
</h3>
@if (!this.rss.botConfig.memoryEnabled) {
<app-hint-memory-required [botConfig]="this.rss.botConfig"></app-hint-memory-required>
}
<p
  class="text-secondary mt-1 mb-1"
  i18n="@@offline-websites-description"
>
  Füge Webseiten hinzu, die einmalig heruntergeladen und gespeichert werden. Die Inhalte – inklusive konfigurierter
  Unterseiten – werden dem LLM bei Bedarf als Wissen übergeben, ohne dass eine Live-Verbindung nötig ist.
</p>
<div class="mb-3">
  <div
    class="mb-1"
    i18n="@@page-url-hint"
  >
    Gib hier eine Website für die Offline-Verfügbarkeit ein.
  </div>
  <input
    pInputText
    placeholder="URL"
    [(ngModel)]="this.offlineWebUrl"
    [ngClass]="{'is-invalid': !this.isUrlValid(this.offlineWebUrl)}"
    fluid
  >
</div>
<div class="mb-3">
  <div
    class="mb-1"
    i18n="@@page-depth-hint"
  >Gib hier die Seitentiefe ein, wie tief die Verlinkungen verfolgt werden sollen.</div>
  <p-inputnumber
    placeholder="Seitentiefe"
    [min]="0"
    [max]="1"
    [step]="1"
    [(ngModel)]="this.offlineWebDepth"
    mode="decimal"
    fluid
  ></p-inputnumber>
</div>
<div class="mb-3">
  <div i18n="@@how-is-the-website-used">
    Bitte erläutere der KI, wofür diese Webseite genutzt werden soll:
  </div>
  <p-inputgroup>
    <p-inputgroup-addon>
      <i
        class="ri-sparkling-fill text-primary"
        style="font-size: 1.2rem;"
      ></i>
    </p-inputgroup-addon>
    <input
      pInputText
      [(ngModel)]="this.offlineWebDescription"
      fluid
    >
  </p-inputgroup>
</div>
<p-button
  severity="primary"
  size="small"
  [ngClass]="{'disabled': !this.isConfigValid()}"
  (onClick)="this.addOfflineWeb()"
>
  <i class="ri-add-line"></i>
  <span i18n="@@add">Hinzufügen</span>
</p-button>
@if (this.rss.webscrapes.length > 0) {
<h5
  class="mt-5"
  i18n="@@avaliable-weppages"
>Verfügbare Websites im Überblick</h5>
}
@if (this.rss.webscrapes.length > 0) {
<p-table
  dataKey="_id"
  [(selection)]="selectedWebscrapes"
  [rowSelectable]="isWebscrapeSelectable"
  [value]="this.rss.webscrapes"
  [rowHover]="true"
  styleClass="p-datatable-sm"
>
  <ng-template pTemplate="header">
    <tr>
      <th class="bot-selection-cell"><p-tableHeaderCheckbox ariaLabel="Alle auswählen" i18n-ariaLabel="@@bulk-select-all" /></th>
      <th i18n="@@status">Status</th>
      <th i18n="@@url">URL</th>
      <th i18n="@@skillid">Skill ID</th>
      <th i18n="@@skill-usage-column">Stage-Zuordnung</th>
      <th i18n="@@onoff">Aus/An</th>
      <th i18n="@@actions">Aktionen</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-webscrape
  >
    <tr>
      <td class="bot-selection-cell"><p-tableCheckbox [value]="webscrape" [disabled]="scrapeIsRunning(webscrape._id)"
        [ariaLabel]="webscrape.url" /></td>
      <td style="width: 4rem;">
        @if (webscrape.loadError) {
        <i
          class="ri-alert-fill text-danger"
          pTooltip="Das Laden ist fehlgeschlagen. Du kannst diesen Eintrag löschen."
          i18n-pTooltip="@@offline-website-load-error"
        ></i>
        }
        @else if (this.scrapeIsRunning(webscrape._id)) { <span class="spinner-border spinner-border-sm ms-1"></span> }
        @else {
        @if (webscrape.active) {
        <i class="ri-circle-fill text-primary"></i>
        }
        @if (!webscrape.active) {
        <i class="ri-circle-line text-secondary"></i>
        }
        }
      </td>
      <td>
        @if (!this.scrapeIsRunning(webscrape._id)) {
        <span
          class="cursor-pointer text-decoration-underline text-primary"
          (click)="showDetailDrawer(webscrape._id)"
        >
          {{ webscrape.url }}
        </span>
        }
        @if (this.scrapeIsRunning(webscrape._id)) {
        <span>
          {{ webscrape.url }}
        </span>
        }
      </td>
      <td style="width:250px">
        <app-skill-id-input
          [value]="webscrape.skillId"
          (changed)="webscrape.skillId = $event; this.service.updateWebscrapeConfig(webscrape)"
        ></app-skill-id-input>
      </td>
      <td>
        <app-skill-usage-list [skillId]="webscrape.skillId"></app-skill-usage-list>
      </td>
      <td style="width: 0rem;">
        <p-toggleswitch
          [(ngModel)]="webscrape.active"
          (ngModelChange)="this.service.updateWebscrapeConfig(webscrape)"
        ></p-toggleswitch>
      </td>
      <td
        style="width: 2rem;"
        class="text-end"
      >
        <p-menu
          #menu
          appendTo="body"
          [model]="webscrapeContextMenu"
          [popup]="true"
        ></p-menu>
        <p-button
          (onClick)="openWebscrapeMenu($event, menu, webscrape)"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          [raised]="true"
          icon="ri ri-more-2-fill"
          [disabled]="scrapeIsRunning(webscrape._id)"
        ></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
<app-bulk-action-bar [actions]="bulkActions" [count]="selectedWebscrapes.length" [allSelected]="allSelected"
  (selectAll)="toggleAll(true)" (clear)="selectedWebscrapes = []" />
}

@if (detailDrawer) {
<p-drawer
  [(visible)]="this.detailDrawer"
  [position]="'right'"
  [modal]="true"
  [closeOnEscape]="true"
  styleClass="w-100 w-md-75 w-lg-50"
>
  @if (this.selectedWebscrapeId) {
  <app-offline-websites-tab-detail
    [selectedWebscrapeId]="this.selectedWebscrapeId"
    (closeDrawer)="this.detailDrawer = false"
  ></app-offline-websites-tab-detail>
  }
</p-drawer>
}